
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'StandardLogo',
  setup() {
    return {};
  },
});
